import { FormField } from '../SchemaForm/SchemaForm.model'

export class SummarySchemaFormUtils {
  static findFormFieldByName = (formFields: FormField[], fieldName: string) =>
    formFields.find(field => field.name === fieldName)
}
